export const cleanData = updateData => {
  Object.keys(updateData).forEach(key =>
    updateData[key] === undefined || updateData[key] === ''
      ? delete updateData[key]
      : {}
  );
  return updateData;
};

export const checkEmptyProps = object => {
  const emptyFields = [];
  Object.keys(object).forEach(key => {
    if (
      object[key] === undefined ||
      object[key] === null ||
      object[key] === ''
    ) {
      emptyFields.push(key);
    }
  });
  return emptyFields;
};
